/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ApiListRunsResponse,
  ApiReportRunMetricsResponse,
  ApiRun,
  ApiRunDetail,
  GoogleRpcStatus,
  RunServiceReportRunMetricsV1Body,
} from '../models/index';
import {
  ApiListRunsResponseFromJSON,
  ApiListRunsResponseToJSON,
  ApiReportRunMetricsResponseFromJSON,
  ApiReportRunMetricsResponseToJSON,
  ApiRunFromJSON,
  ApiRunToJSON,
  ApiRunDetailFromJSON,
  ApiRunDetailToJSON,
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusToJSON,
  RunServiceReportRunMetricsV1BodyFromJSON,
  RunServiceReportRunMetricsV1BodyToJSON,
} from '../models/index';

export interface ArchiveRunRequest {
  id: string;
}

export interface CreateRunRequest {
  run: ApiRun;
}

export interface DeleteRunRequest {
  id: string;
}

export interface GetRunRequest {
  run_id: string;
}

export interface ListRunsRequest {
  page_token?: string;
  page_size?: number;
  sort_by?: string;
  resource_reference_key_type?: ListRunsV1ResourceReferenceKeyTypeEnum;
  resource_reference_key_id?: string;
  filter?: string;
}

export interface ReportRunMetricsRequest {
  run_id: string;
  body: RunServiceReportRunMetricsV1Body;
}

export interface RetryRunRequest {
  run_id: string;
}

export interface TerminateRunRequest {
  run_id: string;
}

export interface UnarchiveRunRequest {
  id: string;
}

/**
 *
 */
export class RunServiceApi extends runtime.BaseAPI {
  /**
   * Archives a run.
   */
  async archiveRunRaw(
    requestParameters: ArchiveRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling archiveRun().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/runs/{id}:archive`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Archives a run.
   */
  async archiveRun(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.archiveRunRaw({ id: id }, initOverrides);
    return await response.value();
  }

  /**
   * Creates a new run.
   */
  async createRunRaw(
    requestParameters: CreateRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiRunDetail>> {
    if (requestParameters['run'] == null) {
      throw new runtime.RequiredError(
        'run',
        'Required parameter "run" was null or undefined when calling createRun().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/runs`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ApiRunToJSON(requestParameters['run']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiRunDetailFromJSON(jsonValue));
  }

  /**
   * Creates a new run.
   */
  async createRun(
    run: ApiRun,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiRunDetail> {
    const response = await this.createRunRaw({ run: run }, initOverrides);
    return await response.value();
  }

  /**
   * Deletes a run.
   */
  async deleteRunRaw(
    requestParameters: DeleteRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling deleteRun().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/runs/{id}`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Deletes a run.
   */
  async deleteRun(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.deleteRunRaw({ id: id }, initOverrides);
    return await response.value();
  }

  /**
   * Finds a specific run by ID.
   */
  async getRunRaw(
    requestParameters: GetRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiRunDetail>> {
    if (requestParameters['run_id'] == null) {
      throw new runtime.RequiredError(
        'run_id',
        'Required parameter "run_id" was null or undefined when calling getRun().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/runs/{run_id}`;
    urlPath = urlPath.replace(
      `{${'run_id'}}`,
      encodeURIComponent(String(requestParameters['run_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiRunDetailFromJSON(jsonValue));
  }

  /**
   * Finds a specific run by ID.
   */
  async getRun(
    run_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiRunDetail> {
    const response = await this.getRunRaw({ run_id: run_id }, initOverrides);
    return await response.value();
  }

  /**
   * Finds all runs.
   */
  async listRunsRaw(
    requestParameters: ListRunsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiListRunsResponse>> {
    const queryParameters: any = {};

    if (requestParameters['page_token'] != null) {
      queryParameters['page_token'] = requestParameters['page_token'];
    }

    if (requestParameters['page_size'] != null) {
      queryParameters['page_size'] = requestParameters['page_size'];
    }

    if (requestParameters['sort_by'] != null) {
      queryParameters['sort_by'] = requestParameters['sort_by'];
    }

    if (requestParameters['resource_reference_key_type'] != null) {
      queryParameters['resource_reference_key.type'] =
        requestParameters['resource_reference_key_type'];
    }

    if (requestParameters['resource_reference_key_id'] != null) {
      queryParameters['resource_reference_key.id'] = requestParameters['resource_reference_key_id'];
    }

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/runs`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiListRunsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Finds all runs.
   */
  async listRuns(
    page_token?: string,
    page_size?: number,
    sort_by?: string,
    resource_reference_key_type?: ListRunsV1ResourceReferenceKeyTypeEnum,
    resource_reference_key_id?: string,
    filter?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiListRunsResponse> {
    const response = await this.listRunsRaw(
      {
        page_token: page_token,
        page_size: page_size,
        sort_by: sort_by,
        resource_reference_key_type: resource_reference_key_type,
        resource_reference_key_id: resource_reference_key_id,
        filter: filter,
      },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * ReportRunMetrics reports metrics of a run. Each metric is reported in its own transaction, so this API accepts partial failures. Metric can be uniquely identified by (run_id, node_id, name). Duplicate reporting will be ignored by the API. First reporting wins.
   */
  async reportRunMetricsRaw(
    requestParameters: ReportRunMetricsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiReportRunMetricsResponse>> {
    if (requestParameters['run_id'] == null) {
      throw new runtime.RequiredError(
        'run_id',
        'Required parameter "run_id" was null or undefined when calling reportRunMetrics().',
      );
    }

    if (requestParameters['body'] == null) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter "body" was null or undefined when calling reportRunMetrics().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/runs/{run_id}:reportMetrics`;
    urlPath = urlPath.replace(
      `{${'run_id'}}`,
      encodeURIComponent(String(requestParameters['run_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RunServiceReportRunMetricsV1BodyToJSON(requestParameters['body']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiReportRunMetricsResponseFromJSON(jsonValue),
    );
  }

  /**
   * ReportRunMetrics reports metrics of a run. Each metric is reported in its own transaction, so this API accepts partial failures. Metric can be uniquely identified by (run_id, node_id, name). Duplicate reporting will be ignored by the API. First reporting wins.
   */
  async reportRunMetrics(
    run_id: string,
    body: RunServiceReportRunMetricsV1Body,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiReportRunMetricsResponse> {
    const response = await this.reportRunMetricsRaw({ run_id: run_id, body: body }, initOverrides);
    return await response.value();
  }

  /**
   * Re-initiates a failed or terminated run.
   */
  async retryRunRaw(
    requestParameters: RetryRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['run_id'] == null) {
      throw new runtime.RequiredError(
        'run_id',
        'Required parameter "run_id" was null or undefined when calling retryRun().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/runs/{run_id}/retry`;
    urlPath = urlPath.replace(
      `{${'run_id'}}`,
      encodeURIComponent(String(requestParameters['run_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Re-initiates a failed or terminated run.
   */
  async retryRun(
    run_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.retryRunRaw({ run_id: run_id }, initOverrides);
    return await response.value();
  }

  /**
   * Terminates an active run.
   */
  async terminateRunRaw(
    requestParameters: TerminateRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['run_id'] == null) {
      throw new runtime.RequiredError(
        'run_id',
        'Required parameter "run_id" was null or undefined when calling terminateRun().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/runs/{run_id}/terminate`;
    urlPath = urlPath.replace(
      `{${'run_id'}}`,
      encodeURIComponent(String(requestParameters['run_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Terminates an active run.
   */
  async terminateRun(
    run_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.terminateRunRaw({ run_id: run_id }, initOverrides);
    return await response.value();
  }

  /**
   * Restores an archived run.
   */
  async unarchiveRunRaw(
    requestParameters: UnarchiveRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling unarchiveRun().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/runs/{id}:unarchive`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Restores an archived run.
   */
  async unarchiveRun(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.unarchiveRunRaw({ id: id }, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const ListRunsV1ResourceReferenceKeyTypeEnum = {
  UNKNOWN_RESOURCE_TYPE: 'UNKNOWN_RESOURCE_TYPE',
  EXPERIMENT: 'EXPERIMENT',
  JOB: 'JOB',
  PIPELINE: 'PIPELINE',
  PIPELINE_VERSION: 'PIPELINE_VERSION',
  NAMESPACE: 'NAMESPACE',
} as const;
export type ListRunsV1ResourceReferenceKeyTypeEnum =
  (typeof ListRunsV1ResourceReferenceKeyTypeEnum)[keyof typeof ListRunsV1ResourceReferenceKeyTypeEnum];
